import React, { Component } from "react";
import { Container, Dropdown, Icon, Menu } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import roleControl from "./../auth/roleControl";
import _ from "lodash";

const RCDropdown = roleControl(["sysadmin", "supervisor", "operator"])(
  Dropdown
);
const RCDropdownItem = roleControl(["sysadmin", "supervisor", "operator"])(
  Dropdown.Item
);
const RCAdminDropdownItem = roleControl(["sysadmin"])(Dropdown.Item);
const RCFinancesDropdownItem = roleControl(["sysadmin", "finances"])(
  Dropdown.Item
);
const RCInquirer = roleControl([
  "sysadmin",
  "supervisor",
  "operator",
  "inquirer"
])(Menu.Item);

class NavigationBar extends Component {
  constructor(props) {
    super(props);
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps(dispatch) {
    return {};
  }

  render() {
    let {
      authentication: { attempting, user }
    } = this.props;

    if (attempting) {
      return null;
    } else {
      return (
        <Menu pointing secondary>
          <Menu.Item
            name="portada"
            as={Link}
            to="/"
            active={!!window.location.pathname.match(new RegExp(`^/$`))}
          />
          <Menu.Item
            name="guia de tramites"
            as={Link}
            to="/tramites"
            active={
              !!window.location.pathname.match(new RegExp(`^/tramites\/?$`))
            }
          />
          <Menu.Menu position="right">
            {user && (
              <RCInquirer
                as={Link}
                to="/informes"
                key="informes"
                name="informes"
                icon="book"
                active={
                  !!window.location.pathname.match(new RegExp(`^/informes\/?$`))
                }
              />
            )}
            {user && (
              <RCDropdown text="Administrar" pointing className="link item">
                <Dropdown.Menu>
                  <Dropdown.Item
                    as={Link}
                    to="/cooperativas"
                    key="cooperativas"
                    name="cooperativas">
                    Cooperativas
                  </Dropdown.Item>
                  <RCFinancesDropdownItem
                    as={Link}
                    to="/financiero"
                    key="financiero"
                    name="financiero">
                    Financiero
                  </RCFinancesDropdownItem>
                  <RCAdminDropdownItem
                    as={Link}
                    to="/miscelaneos"
                    key="miscelaneos"
                    name="miscelaneos">
                    Miscelaneos
                  </RCAdminDropdownItem>
                  <RCDropdownItem
                    as={Link}
                    to="/personas"
                    key="personas"
                    name="personas">
                    Personas
                  </RCDropdownItem>
                  <Dropdown.Divider />
                  <RCAdminDropdownItem as={Link} to="/public">
                    Publico
                  </RCAdminDropdownItem>
                </Dropdown.Menu>
              </RCDropdown>
            )}
            {!user && (
              <Menu.Item
                as={Link}
                to="/ingresar"
                key="ingresar"
                name="ingresar"
                icon="sign in"
              />
            )}
            {user && (
              <Menu.Item
                as={Link}
                to="/profile"
                active={
                  !!window.location.pathname.match(new RegExp(`^/profile\/?$`))
                }
                key="profile"
                name="perfil"
              />
            )}
            {user && (
              <Menu.Item
                as={Link}
                to="/cerrar-sesion"
                name="cerrar session"
                active={
                  !!window.location.pathname.match(
                    new RegExp(`^/cerrar-sesion\/?$`)
                  )
                }
                key="cerrar-sesion"
                icon="sign out"
              />
            )}
          </Menu.Menu>
        </Menu>
      );
    }
  }
}

export default connect(
  NavigationBar.mapStateToProps,
  NavigationBar.mapDispatchToProps
)(NavigationBar);



// WEBPACK FOOTER //
// ./client/components/navigation/NavigationBar.js